const editingRedraws = new Set()

// Never morph the V3 dialog stack or anything inside it: idiomorph can
// strip a dialog's `open` attribute or recreate the node while the browser
// keeps its top-layer entry, leaving the page inert under a ghost dialog
// (hotwired/turbo#1239). The stack is client-state — dialogs are appended
// and removed by explicit streams, so a morphing page render must leave it
// alone entirely. The one morph let in is a redraw of an element inside a
// dialog that `keep_editing_field` turned into a morph, and never across a dialog.
export function holdDialogStack (event) {
  if (!document.getElementById('dialogs')?.contains(event.target)) return false
  if (redrawnForEditing(event.target)) return false

  event.preventDefault()
  return true
}

export async function morphingForEditing (targets, render) {
  editingRedraws.add(targets)
  try {
    return await render()
  } finally {
    editingRedraws.delete(targets)
  }
}

function redrawnForEditing (node) {
  if (node.matches?.('dialog') || node.querySelector?.('dialog')) return false

  return [...editingRedraws].some((targets) => targets.some((target) => target.contains(node)))
}
